import { Controller } from "@hotwired/stimulus"

// Swaps the casting photo the moment a different model is chosen, instead of
// waiting for a save and reload. Each option carries its model's thumbnail on a
// data attribute, so this is a pure swap — no request, nothing to go stale.
export default class extends Controller {
  static targets = ["select", "photo", "empty"]

  change() {
    const option = this.selectTarget.selectedOptions[0]
    const src    = option && option.dataset.thumb

    if (this.hasPhotoTarget) {
      this.photoTarget.src    = src || ""
      this.photoTarget.hidden = !src
      this.photoTarget.alt    = option ? option.textContent.trim() : ""
    }
    // Some models have no rendered polaroid; keep the slot from collapsing.
    if (this.hasEmptyTarget) this.emptyTarget.hidden = !!src
  }
}
